export const MasterDataStatusBadge = ({ status }) => {
    const isActive = status === "Aktif" || status === "aktif";
    return (
      <span
        className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold tracking-wide ${
          isActive
            ? "bg-emerald-500/12 text-emerald-400 border border-emerald-500/20"
            : "bg-red-500/12 text-red-400 border border-red-500/20"
        }`}
      >
        <span className={`w-1.5 h-1.5 rounded-full ${isActive ? "bg-emerald-400" : "bg-red-400"}`} />
        {status}
      </span>
    );
  };